import React from 'react';

const ServicoIcon = ({ color = '#233d4d', size = 30 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 31 30">
    <g id="Grupo_504" data-name="Grupo 504" transform="translate(-37 -164)">
      <path
        id="Icon_awesome-hand-holding"
        data-name="Icon awesome-hand-holding"
        d="M30.422,23.07a1.477,1.477,0,0,0-2.293,0l-4.973,5.2A2.968,2.968,0,0,1,21,29.25H14.638a1.165,1.165,0,0,1,0-2.25h4.214a1.977,1.977,0,0,0,1.792-1.87c.178-1.406-.651-2.63-1.7-2.63H10.333a5.5,5.5,0,0,0-3.988,1.849L3.842,27H.861A1.023,1.023,0,0,0,0,28.125v6.75A1.023,1.023,0,0,0,.861,36h19.2a2.986,2.986,0,0,0,2.153-.984l8.137-8.508A2.721,2.721,0,0,0,30.422,23.07Z"
        transform="translate(37 158)"
        fill={color}
      />
      <path
        id="Icon_material-settings"
        data-name="Icon material-settings"
        d="M14.872,10.137a4.361,4.361,0,0,0,0-1.274l1.41-1.072a.322.322,0,0,0,.08-.416L15.026,5.126a.34.34,0,0,0-.408-.143l-1.664.65A4.917,4.917,0,0,0,11.825,5l-.254-1.722A.323.323,0,0,0,11.244,3H8.571a.323.323,0,0,0-.327.273L7.99,5a5.17,5.17,0,0,0-1.129.637L5.2,4.983a.33.33,0,0,0-.408.143L3.452,7.374a.315.315,0,0,0,.08.416l1.41,1.072A5.017,5.017,0,0,0,4.9,9.5a5.017,5.017,0,0,0,.047.637l-1.41,1.073a.322.322,0,0,0-.08.416l1.336,2.249a.34.34,0,0,0,.408.143l1.664-.65A4.917,4.917,0,0,0,7.99,14l.254,1.722A.323.323,0,0,0,8.571,16h2.673a.323.323,0,0,0,.327-.273L11.825,14a5.17,5.17,0,0,0,1.129-.637l1.664.65a.33.33,0,0,0,.408-.143l1.336-2.249a.322.322,0,0,0-.08-.416l-1.41-1.073ZM9.907,11.775A2.276,2.276,0,1,1,12.246,9.5,2.31,2.31,0,0,1,9.907,11.775Z"
        transform="translate(48.912 161)"
        fill={color}
      />
    </g>
  </svg>
);

export default ServicoIcon;
